import { create } from 'zustand'

type IngredientsPageDataStoreType = {
  searchQuery: string
  setSearchQuery: (query: string) => void
}

export const useIngredientsPageSearchQuery = create<IngredientsPageDataStoreType>(set => ({
  searchQuery: '',
  setSearchQuery(searchQuery) {
    set(() => ({ searchQuery }))
  },
}))
